import { Pipe, PipeTransform } from "@angular/core";
import { TicketProvider } from "../../providers/ticket";

@Pipe({
  name: "ticket"
})
export class TicketPipe implements PipeTransform {

  constructor(
    private ticketService: TicketProvider
  ) { }

  transform(ticketId: string, clientId: string) {
    return this.ticketService.getTicketById(clientId, ticketId);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/ticket/ticket.ts